import { createRouter } from '@tanstack/react-router'

import * as QueryClientProvider from '@/data/query-client-provider'

import { Route as rootRoute } from './__root'
import { Route as notFoundRoute } from './404'
import { Route as hppSessionRoute } from './hpp-session'
import { Route as tokenizationSessionRoute } from './tokenization-session'
import { Route as transactionSessionRoute } from './transaction-session'

const routeTree = rootRoute.addChildren([
  transactionSessionRoute,
  tokenizationSessionRoute,
  hppSessionRoute,
  notFoundRoute,
])

export const router = createRouter({
  routeTree,
  context: {
    ...QueryClientProvider.getContext(),
  },
  defaultPreload: 'intent',
  defaultComponent: () => null,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
